import { IServiceResponse } from "../../../interfaces/service.response";
import { IServiceRequest } from "../../../interfaces/service.request";
//import { BoxQuotaData } from "../.././box.quote.data";
import { DataService } from "../../../services/data/data.service";
import {
    HistoryItemPeriod,
    getRangeFromHistoryItemPeriod,
    getHistoryItemPeriodValue,
    IHistoryItem,
    PERIOD_TIMESTAMP_MULTIPLIER
} from "../../../interfaces/historyItem";

import { QuoteTabWizardComponent } from "../../../components/quoteTabWizard/quoteTabWizard.component";
import { Workspace } from "../../../model/workspace.data";
import { BoxQuotaData } from "../../../model/box.quote.data";
import { ScannerInstrumentList, ScannerSide } from "../interfaces/scanner.enums";
import { IEntrySignalsScanData, responseIds, ITIScanRule, ITIWizardResultData } from "../interfaces/scanner.interfaces";
import { computeValueES_Scanner } from "./Math/entrySignals.Math";
import { computeCHWScan } from "./Math/chWizard.Math";
import { computeRSIScan } from "./Math/rsiCharting.Math";
import { computeEmaScan } from "./Math/emaCharting.Math";
import { computeMacdScan } from "./Math/macdCharting.Math";
import { computeBbScan } from "./Math/bbCharting.Math";
import { computeTIScan, NumberIsBetween } from "./Math/tiWizard.Math";
import { computeValueES } from "../../../model/monitor.selected.symbol";
import {ScannerState, scannerActiveState} from "./scanState";

export class scanData  extends ScannerState  {
    

    constructor(
        private dataService: DataService,
        private workspace: Workspace,
        public Symbol: string,
        public limit: number = 100,
        public scanInstrument: ScannerInstrumentList
    ) {
        super();

        this._dataScan = this._dataScan || anychart.data.table();

        this.dataService.dataSubscriber.subscribe(response => {
           
            if (response.Type == "HistoricalDataRs") {
           
                if(this.Symbol == response.Symbol)
                {
                    if(this.context.activeState != scannerActiveState.Scanner_ScanFinished)
                    {
                            this.response = response;
                            this.context.dataReceived();
                    }
                   
                }
              
                
            }
        });
       
    }


    //////////////////SCANNERSTATES

    public timeLimit:number = 15000;
    public scannerTimeOut?:any;
    public waitingForDataTimeout?:any;
    public response?:IServiceResponse;

public log()
{
  // console.log(`${this.Symbol} - ${this.context.activeState}`);
}

    public init() {

        this.log();
        this.context.waitingForData();

    };

    public waitingForData(){

        this.log();

        try{
            if(this.scanInstrument != ScannerInstrumentList.SCANNER_ENTRYSIGNALS)
            {
                this.requestForData();
            }
            else
            {
                this.runEntrySignalSymbolScan();
            }
            this.waitingFor();

            this.scannerTimeOut = setTimeout(() => {
                this.context.scanFinished();
            }, this.timeLimit);
        }
        catch(e)
        {
            console.log(e)
            this.context.scanFinished();
        }

    };

    public wfCount:number = 0;
    public waitingFor()
    {
        this.waitingForDataTimeout = setTimeout(() => {
            
            console.log(`WAITING FOR ${this.Symbol} - ${this.wfCount}seconds`);
            this.wfCount++;
            this.waitingFor();
        }, 1000);
    }

    public  dataReceived(){ 

        try{
            if(this.response && this.response.Periods  && this.response.Periods.length>0)
            { 
               this.log();

                if(this.context.activeState != scannerActiveState.Scanner_ScanFinished)
                this.updateData(this.response);
            
            }
            else
            {
                console.log((`DATA EMPTY - ${this.Symbol} - ${this.response}`))
                this.context.scanFinished();
            }
        }
        catch(e)
        {
            console.log(e)
            this.context.scanFinished();
        }

    };

    public scanFinished(){

        try{
        if(this.scannerTimeOut)
        {
             clearTimeout(this.scannerTimeOut);
        }

        if(this.waitingForDataTimeout)
        {
            clearTimeout(this.waitingForDataTimeout);
        }

        this.workspace.scannedCount++;
        this.log();
        }
        catch(e)
        {
            console.log(e)
            this.context.scanFinished();
        }


     };


     ///////////////////DATAPROCESSING

    public get box(): BoxQuotaData {
        return this.workspace.boxes.filter(x => x.Symbol == this.Symbol)[0];
    }

  
    _dataScan: anychart.data.Table | undefined;

    private _selectedPeriod: HistoryItemPeriod | string = HistoryItemPeriod.Min30;
    public get selectedPeriod(): HistoryItemPeriod | string {
        return this._selectedPeriod;
    }
    public set selectedPeriod(value: HistoryItemPeriod | string) {
        this._selectedPeriod = value;
    }

    private _ModeChWizard: string = "HIGH";
    public get ModeChWizard(): string {
        return this._ModeChWizard;
    }
    public set ModeChWizard(value: string) {
        this._ModeChWizard = value;
    }

    private _narrowScan: boolean = false;
    public get narrowScan (): boolean {
        return this._narrowScan;
    }
    public set narrowScan ( value: boolean ) {
        this._narrowScan = value;
    }















    public quoteTabObj?: QuoteTabWizardComponent;
    private _defaultNumberofPoints: number = 800;
    public get defaultNumberofPoints(): number {
        return this._defaultNumberofPoints;
    }

    public set defaultNumberofPoints(value: number) {
        this._defaultNumberofPoints = value;
    }

    public requestForData(v: any = null): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this._dataScan = this._dataScan || anychart.data.table();
            //     if (v != null) {

          
         //   if (this.reqId == "") {
                this.requestPeriod(this._dataScan, this.selectedPeriod, this.defaultNumberofPoints)
                    .then(r => {
                       
                        
                        rs();
                    })
                    .catch(e => {console.log("ERRREQ" + this.Symbol)});
        //    }

            //     }
        });
    }

    ///*ES STAART*/
    public requestForEntryData(v?: HistoryItemPeriod, type?: string): Promise<void> {
        return new Promise<void>((rs, rj) => {
            this._dataScan = this._dataScan || anychart.data.table();
            //     if (v != null) {

            //   if(this.reqId=="")
            //    {
            this.requestPeriod(this._dataScan, v, this.defaultNumberofPoints, type)
                .then(r => {
                    rs();
                })
                .catch(e => {});
            //     }

            //     }
        });
    }

    private _hardFinished = false;
    public get hardFinished () {
        return this._hardFinished;
    }
    public set hardFinished ( value ) {
        this._hardFinished = value;
    }
    public entrySignalperiodsList?: IEntrySignalsScanData;
    public responseForSignalTypes: responseIds[] = [];
    public runEntrySignalSymbolScan() {
        if (this.entrySignalperiodsList != undefined) {
            this.requestForEntryData(this.entrySignalperiodsList.LData.period, "L");
            this.requestForEntryData(this.entrySignalperiodsList.MData.period, "M");
            this.requestForEntryData(this.entrySignalperiodsList.SData.period, "S");
            this.requestForEntryData(this.entrySignalperiodsList.EData.period, "E");
        }
        // this.workspace.scannedCount++;
    }
    /**ES END */

    public reqId?: string = "";
    private requestPeriod(data: anychart.data.Table, period: any, limit: number, type?: string): Promise<string> {
        return new Promise<string>((rs, rj) => {
            data.remove();

            this.reqId = "";

            this.dataService
                .tryToGetFromCache(this.Symbol, period, limit)
                .then(r => {
                    var Periods: IHistoryItem[] = [];
                    Periods = Periods.concat(r.Periods || []);

                    r.ReqID = `${new Date().getTime()}.${Math.random()}.'_'.${this.Symbol}.'_'.${period}.'_'.${limit}`; // dumy local id

                  //  setTimeout(() => {
                        this.reqId = r.ReqID;

                        if (type !== undefined) {
                            this.responseForSignalTypes.push({ scantype: type, scanReqId: r.ReqID });
                        }

                        this.response = r;
                        this.context.dataReceived();
                     //   this.updateData(r);
                 //   }, 50);

                    rs(r.ReqID);
                })
                .catch(() => {
                    this.dataService
                        .sendHistoryRequest(this.Symbol, period, limit)
                        .then(r => {
                            this.reqId = r;

                            if (type !== undefined) {
                                this.responseForSignalTypes.push({ scantype: type, scanReqId: r });
                            }

                            rs(r);
                        })
                        .catch(e => {});
                });
        });
    }

    private async updateData(response: IServiceResponse) {
    
        
        var Periods: IHistoryItem[] = [];
        Periods = Periods.concat(response.Periods || []);
        //  var P = (response.P || []).filter(pu => pu.Symbol == this.Symbol);

        //   var T = (response.T || []).filter(t => t.S == this.Symbol);
            this._dataScan = undefined
      
        if (Periods.length > 0) {
            //let pip: number = 0.0001;//this._pip;
            this._dataScan = this._dataScan || anychart.data.table();

            let hasData = false;
            if (this.scanInstrument == ScannerInstrumentList.SCANNER_ENTRYSIGNALS) {
                // hasData = true;
                hasData =
                    this.responseForSignalTypes.filter(v => {
                        return v.scanReqId == response.ReqID;
                    }).length > 0
                        ? true
                        : false;
            }

            if (
                this.scanInstrument == ScannerInstrumentList.SCANNER_CHWIZARD ||
                this.scanInstrument == ScannerInstrumentList.SCANNER_TIWIZARD ||
                this.scanInstrument == ScannerInstrumentList.SCANNER_CHARTING_RSI ||
                this.scanInstrument == ScannerInstrumentList.SCANNER_CHARTING_BOLLINGERBANDS ||
                this.scanInstrument == ScannerInstrumentList.SCANNER_CHARTING_EMA ||
                this.scanInstrument == ScannerInstrumentList.SCANNER_CHARTING_MACD
            ) {
                hasData = response.ReqID == this.reqId ? true : false;
            }
           
            // if ( hasData) {

            if (hasData) {

             
                // if(this.Symbol=="EUR/GBP")
                // {
                //     debugger;
                // }


                let data: number[][] = Periods.map(element => {
                    // candlestick point data
                    // [0] - data/time
                    // [1] - open
                    // [2] - high
                    // [3] - low
                    // [4] - close
                    // [5] - volume
                    // [6] - spot
                    return [element.t * PERIOD_TIMESTAMP_MULTIPLIER, element.o, element.h, element.l, element.c, element.v, 0];
                });

                
                let dataOrder = data[0][0]-data[1][0];


                if(dataOrder>0)
                {
                    data.reverse();
                }
          //      
          //      data.splice(-1,1);

                this._dataScan.addData(data);
                if(this.Symbol=="EUR/CHF")
                {
               //     console.log(response.Period,response.Symbol);
             //       console.log(data);
                }


                // this.reqId = "";

                switch (this.scanInstrument) {
                    case ScannerInstrumentList.SCANNER_CHWIZARD:
                        this.chWizardComputeResults(this._dataScan, this.ModeChWizard);
                    break;
                    case ScannerInstrumentList.SCANNER_TIWIZARD:
                      this.tiWizardComputeResults(this._dataScan, data, <HistoryItemPeriod>this.selectedPeriod);
                    break;
                    case ScannerInstrumentList.SCANNER_ENTRYSIGNALS:
                        console.log(this.Symbol);
                        this.entrysignalsMergeResults(this._dataScan, response.ReqID, data, response.Period);
                    break;

                    case ScannerInstrumentList.SCANNER_CHARTING_RSI:
                        this.rsiComputeResults(this._dataScan);
                        break;

                    case ScannerInstrumentList.SCANNER_CHARTING_BOLLINGERBANDS:
                        this.bbComputeResults(this._dataScan);
                        break;

                    case ScannerInstrumentList.SCANNER_CHARTING_EMA:
                        this.emaComputeResults(this._dataScan);
                        break;

                    case ScannerInstrumentList.SCANNER_CHARTING_MACD:
                        this.macdComputeResults(this._dataScan);
                    break;
                }
            }
        }
    }

    public chWizardComputeResults(data: anychart.data.Table, mode: string = "HIGH") {
    
        let computeSMA = computeCHWScan(data, mode, this.Symbol);
        
        let resultRow: ICHWizardResultRow = {
            symbol: this.Symbol,
            value: computeSMA
        };

        if(!this.narrowScan)
        this.workspace.scanResultList.push(resultRow);

        if(this.narrowScan)
        this.workspace.scanResultListNarrow.push(resultRow);

        console.log(resultRow);
        this.context.scanFinished();
    }



    public tiRule:ITIScanRule = {};
    public tiWizardComputeResults(data: anychart.data.Table, historyData:number[][], period:HistoryItemPeriod) {
 

            let box = this.workspace.boxes.find(v=>v.Symbol == this.Symbol)

         let doNotAddToResultList:boolean = false;
         let computeTI = computeTIScan(data,historyData,this.Symbol,period,box);

     
        
         let resultRow: ITIWizardResultRow = {
             symbol: this.Symbol,
             value: computeTI
         };

         let allow = 0;
         if(this.tiRule.volatility)
         {
             if(computeTI.volatility)
             {
                 if(!NumberIsBetween(computeTI.volatility,this.tiRule.volatility.from,this.tiRule.volatility.to))
                 {
                     if(this.tiRule.volatility.from==0 && computeTI.volatility<0 || this.tiRule.volatility.to==150 && computeTI.volatility>150)
                     {
                        allow++ ;
                     }
                     else
                     {
                        //  return
                        doNotAddToResultList = true
                     }
                   
                 }
             }
             else
             {
                 allow++;
             }
            
         }

         if(this.tiRule.momentum)
         {
             if(computeTI.momentum)
             {
                 if(!NumberIsBetween(computeTI.momentum,this.tiRule.momentum.from,this.tiRule.momentum.to))
                 {
                     if(this.tiRule.momentum.from==-100 && computeTI.momentum<-100 || this.tiRule.momentum.to==100 && computeTI.momentum>100)
                     {
                        allow++ ;
                     }
                     else
                     {
                        //  return
                        doNotAddToResultList = true
                     }
                   
                 }
             }
             else
             {
                 allow++;
             }
            
         }

         if(this.tiRule.buyingselling)
         {
             if(computeTI.buyandsell)
             {
                 if(!NumberIsBetween(computeTI.buyandsell,this.tiRule.buyingselling.from,this.tiRule.buyingselling.to))
                 {
                     if(this.tiRule.buyingselling.from==-100 && computeTI.buyandsell<-100 || this.tiRule.buyingselling.to==100 && computeTI.buyandsell>100)
                     {
                        allow++ ;
                     }
                     else
                     {
                        //  return
                        doNotAddToResultList = true
                     }
                   
                 }
             }
             else
             {
                 allow++;
             }
            
         }

         if(!this.narrowScan && !doNotAddToResultList)
         {
              this.workspace.scanResultList.push(resultRow);
         }
        

         if(this.narrowScan && !doNotAddToResultList)
         {
              this.workspace.scanResultListNarrow.push(resultRow);
         }
        




    

         this.context.scanFinished();
     

     }

    public entrysignalsMergeResults(data: anychart.data.Table, responseId?: string, dataT?:any,period?:any) {
        this.scanForSymbol = 0;
        this.responseForSignalTypes.forEach(v => {
            if (v.scanReqId == responseId) {
                if (this._dataScan !== undefined) {
                    // v.computedVal = <any>computeValueES_Scanner(this._dataScan)[0];
                    // v.full = computeValueES_Scanner(this._dataScan);
                    v.computedVal = <any>computeValueES(data,undefined,period)[0];
                    v.full = computeValueES(data);
                    v.data = dataT

                    if(this.Symbol=="EUR/CHF" && period==3)
                    {
                            console.log([v.computedVal,v.data, v.full])
                    }
                }
            }

            if (v.computedVal !== undefined) {
                this.scanForSymbol++;
            }
        });

        if (this.scanForSymbol == 4) {
            let resultsTable = this.responseForSignalTypes.map(v => {
                return v.computedVal;
            });

           

            let resultRowEA: IESResultRow = {
                symbol: this.Symbol,
                value: resultsTable,
                responseIds:this.responseForSignalTypes
            };

            if(!this.narrowScan)
            this.workspace.scanResultList.push(resultRowEA);

            if(this.narrowScan)
            {

                    this.workspace.scanResultListNarrow.push(resultRowEA);
            }

           
          
            
            this.context.scanFinished();
        }
       
    }

    public scanForSymbol = 0;

    public rsiRule: any;
    public rsiComputeResults(data: anychart.data.Table) {
       

        let computeInfo = computeRSIScan(data, this.rsiRule);

        let resultRow: IRsiResultRow = {
            symbol: this.Symbol,
            value: computeInfo
        };

       

        if (computeInfo != false && computeInfo != true) {
            let crossInfo = computeInfo[computeInfo.length - 1].direction;

            if (this.rsiRule.direction == ScannerSide.SCANNER_SIDE_SELL && crossInfo == "over") {

                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);


            }

            if (this.rsiRule.direction == ScannerSide.SCANNER_SIDE_BUY && crossInfo == "under") {
                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);
            }
        }

      //  this.workspace.scannedCount++;
      this.context.scanFinished();
    }

    public bbRule: any;
    public bbComputeResults(data: anychart.data.Table) {
        let computeInfo = computeBbScan(data, this.bbRule);
       
        let resultRow: IBBResultRow = {
            symbol: this.Symbol,
            value: computeInfo
        };

     

        let core = resultRow.value[0];
        if (resultRow.value[1][resultRow.value[1].length - 1] != undefined) {
            let result = resultRow.value[1][resultRow.value[1].length - 1].direction;

            if (this.bbRule.direction == ScannerSide.SCANNER_SIDE_BUY && core == "middle" && result == "under") {

                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);
            }

            if (this.bbRule.direction == ScannerSide.SCANNER_SIDE_BUY && core == "lower" && result == "over") {

                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);
            
            }

            if (this.bbRule.direction == ScannerSide.SCANNER_SIDE_SELL && core == "middle" && result == "over") {
                
                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);

            }

            if (this.bbRule.direction == ScannerSide.SCANNER_SIDE_SELL && core == "upper" && result == "under") {
                
                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);

               
            }
        }

        this.context.scanFinished();
        // }
    }

    public macdRule: any;
    public macdComputeResults(data: anychart.data.Table) {
        //  let computeSMA = computeCHWScan(data, mode);
        let computeInfo = computeMacdScan(data, this.macdRule);
        
        let resultRow: IMacdResultRow = {
            symbol: this.Symbol,
            value: computeInfo
        };

      

       

        if (computeInfo != false && computeInfo != true) {
            let crossInfo = computeInfo[computeInfo.length - 1].direction;

            if (this.macdRule.direction == ScannerSide.SCANNER_SIDE_BUY && crossInfo == "over") {
               
                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);

            }

            if (this.macdRule.direction == ScannerSide.SCANNER_SIDE_SELL && crossInfo == "under") {
               
                if(!this.narrowScan)
                this.workspace.scanResultList.push(resultRow);

                if(this.narrowScan)
                this.workspace.scanResultListNarrow.push(resultRow);

            }
        }

        this.context.scanFinished();
    }

    public emaRule: any;
    public emaComputeResults(data: anychart.data.Table) {
       

        let computeInfo = computeEmaScan(data, this.emaRule);

        let resultRow: IEmaResultRow = {
            symbol: this.Symbol,
            value: computeInfo
        };

     

      

        if (computeInfo != false && computeInfo != true) {
            let crossInfo = computeInfo[computeInfo.length - 1].direction;

            if (this.emaRule.direction == ScannerSide.SCANNER_SIDE_SELL && crossInfo == "over") {
                this.workspace.scanResultList.push(resultRow);
            }

            if (this.emaRule.direction == ScannerSide.SCANNER_SIDE_BUY && crossInfo == "under") {
                this.workspace.scanResultList.push(resultRow);
            }
        }

        this.context.scanFinished();
    }
}
export interface ICHWizardResultRow {
    symbol: string;
    value: number;
}

export interface ITIWizardResultRow {
    symbol: string;
    value: ITIWizardResultData;
}


export interface IESResultRow {
    symbol: string;
    value: (number | undefined)[];
    responseIds:any;
}

export interface IRsiResultRow {
    symbol: string;
    value: any;
}

export interface IBBResultRow {
    symbol: string;
    value: any;
}

export interface IEmaResultRow {
    symbol: string;
    value: any;
}

export interface IMacdResultRow {
    symbol: string;
    value: any;
}

//////////////////////////////////////
export const atrPeriod = 14;
export function computeVolatility(
    data: anychart.data.Table,
    endDate?: number,
    period?: HistoryItemPeriod,
    startDate: number = -2
) {
    var atrCtx: anychart.math.atr.Context = anychart.math.atr.initContext(atrPeriod);

    var mapping = data.mapAs();

    mapping.addField("dt", 0); // key - DateTime
    mapping.addField("open", 1);
    mapping.addField("high", 2);
    mapping.addField("low", 3);
    mapping.addField("close", 4);
    mapping.addField("volume", 5);

    if (startDate == -2) {
        startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
    }

    var sel =
        startDate > 0 && endDate
            ? mapping.createSelectable().select(startDate, endDate)
            : mapping.createSelectable().selectAll();
    var iterVolumeMa = sel.getIterator();

    let Atr: number[] = [];
    let i = 0;
    while (iterVolumeMa.advance()) {
        //  var dt = iterBlack.get("dt");
        var c = iterVolumeMa.get("close");
        var h = iterVolumeMa.get("high");
        var l = iterVolumeMa.get("low");

        if (i == 0) {
          
            i++;
        }

        var black = anychart.math.atr.calculate(atrCtx, c, h, l);
        if (!isNaN(black)) {
            Atr.push(black);
        }
    }

    let max = Math.max(...Atr);
    let last = Atr[Atr.length - 1];

    let scaleVal = (150 * last) / max;

    return scaleVal;
}
